import { GeoIPInfo } from '@triplabo/web/services/types';
import { action, observable, computed } from 'mobx';
import { DEFAULT_COORDINATE as defaultCoordinate } from '@triplabo/web/utils/map';
const JP_REGION = 'JP';

export class Geo {
  @observable accessor geoIpInfo: GeoIPInfo = {
    city: '',
    region: '',
    cityLatLong: ''
  };

  @computed
  get isJP() {
    return this.geoIpInfo.region === JP_REGION;
  }

  @computed
  get getCityLatLong() {
    const [lat, lng] = this.geoIpInfo.cityLatLong.split(',').map(Number);
    if (this.isJP) {
      return {
        lat,
        lng
      };
    }
    return {
      lat: defaultCoordinate.latitude,
      lng: defaultCoordinate.longitude
    };
  }

  @action
  setGeoIpInfo(geoIpInfo: GeoIPInfo) {
    this.geoIpInfo = geoIpInfo;
  }
}

const geo = new Geo();

export default geo;
